import { Router } from '@angular/router';
import { AppHttpClient } from '../../core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/http/app-http-client.service";
import * as i2 from "@angular/router";
var MailTemplatesResolve = /** @class */ (function () {
    function MailTemplatesResolve(http, router) {
        this.http = http;
        this.router = router;
    }
    MailTemplatesResolve.prototype.resolve = function (route) {
        var _this = this;
        return this.http.get('mail-templates').toPromise().then(function (response) {
            return response;
        }, function () {
            _this.router.navigate(['/admin']);
            return false;
        });
    };
    MailTemplatesResolve.ngInjectableDef = i0.defineInjectable({ factory: function MailTemplatesResolve_Factory() { return new MailTemplatesResolve(i0.inject(i1.AppHttpClient), i0.inject(i2.Router)); }, token: MailTemplatesResolve, providedIn: "root" });
    return MailTemplatesResolve;
}());
export { MailTemplatesResolve };
